// assets/product-swiper.js
class ProductSwiper {
  constructor() {
    this.mainSwiper = null;
    this.thumbsSwiper = null;
    this.initialized = false;
  }

  init() {
    if (this.initialized) return;
    
    const mainSwiperEl = document.querySelector('.main-product-swiper');
    if (!mainSwiperEl) return;

    // Main swiper configuration
    this.mainSwiper = new Swiper('.main-product-swiper', {
      direction: 'horizontal',
      loop: false,
      speed: 500,
      spaceBetween: 0,
      grabCursor: true,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2,
        loadOnTransitionStart: true,
      },
      watchSlidesProgress: true,
      
      // Navigation
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      
      // Pagination
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
      },
      
      // Keyboard control
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      
      // Breakpoints
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        750: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        990: {
          slidesPerView: 1,
          spaceBetween: 0,
        }
      },
      
      // Events
      on: {
        init: () => this.onSwiperInit(),
        slideChange: () => this.onSlideChange(),
        lazyImageReady: (swiper, slideEl, imageEl) => this.onImageLoad(slideEl, imageEl),
      }
    });

    // Initialize thumbnail swiper if exists
    this.initThumbnailSwiper();
    
    this.initialized = true;
  }

  initThumbnailSwiper() {
    const thumbsEl = document.querySelector('.thumbnail-product-swiper');
    if (!thumbsEl) return;

    this.thumbsSwiper = new Swiper('.thumbnail-product-swiper', {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      watchSlidesProgress: true,
      centerInsufficientSlides: true,
      
      breakpoints: {
        320: {
          slidesPerView: 4,
          spaceBetween: 6,
        },
        750: {
          slidesPerView: 5,
          spaceBetween: 8,
        },
        990: {
          slidesPerView: 6,
          spaceBetween: 10,
        }
      },
      
      on: {
        init: () => {
          // Connect swipers
          this.mainSwiper.controller.control = this.thumbsSwiper;
          this.thumbsSwiper.controller.control = this.mainSwiper;
          
          // Add thumbnail click events
          this.addThumbnailEvents();
        }
      }
    });
  }

  addThumbnailEvents() {
    const thumbs = document.querySelectorAll('.thumbnail-swiper .swiper-slide');
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        this.mainSwiper.slideTo(index);
        this.updateActiveThumb(index);
      });
    });
  }

  updateActiveThumb(index) {
    document.querySelectorAll('.thumbnail-swiper .swiper-slide').forEach((thumb, i) => {
      thumb.classList.toggle('swiper-slide-thumb-active', i === index);
    });
  }

  onSwiperInit() {
    console.log('Product swiper initialized');
    this.updateActiveThumb(0);
    
    // Dispatch custom event
    document.dispatchEvent(new CustomEvent('productSwiper:init', {
      detail: { swiper: this.mainSwiper }
    }));
  }

  onSlideChange() {
    const activeIndex = this.mainSwiper.activeIndex;
    this.updateActiveThumb(activeIndex);
    
    // Update variant if needed
    this.handleVariantUpdate(activeIndex);
  }

  onImageLoad(slideEl, imageEl) {
    // Add loaded class for animation
    imageEl.classList.add('loaded');
    
    // Dispatch event for any post-load actions
    const mediaId = slideEl.dataset.mediaId;
    document.dispatchEvent(new CustomEvent('productMedia:loaded', {
      detail: { mediaId, imageEl }
    }));
  }

  handleVariantUpdate(slideIndex) {
    // If you need to update variant based on slide change
    const slide = this.mainSwiper.slides[slideIndex];
    if (slide) {
      const mediaId = slide.dataset.mediaId;
      // Handle variant logic here if needed
    }
  }

  destroy() {
    if (this.mainSwiper) {
      this.mainSwiper.destroy(true, true);
    }
    if (this.thumbsSwiper) {
      this.thumbsSwiper.destroy(true, true);
    }
    this.initialized = false;
  }

  update() {
    if (this.mainSwiper) {
      this.mainSwiper.update();
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const productSwiper = new ProductSwiper();
  productSwiper.init();

  // Handle variant changes
  document.addEventListener('variant:change', () => {
    productSwiper.update();
  });

  // Handle window resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      productSwiper.update();
    }, 250);
  });

  // Make swiper available globally if needed
  window.productSwiper = productSwiper;
});